/**
 * @flow
 */
/* eslint-disable jsx-a11y/media-has-caption */
/** the above eslint-rule says to add captions for a video tag but it is not required for muted videos */

import React from 'react'

import { tablet } from '../../../utils/mixins'
import { isTabletDesktopDevice } from '../../../utils/responsiveUtils'
import Button from '../ButtonComponent'
import ButtonTextWithIcon from '../ButtonTextWithIcon'
import SkewComponent from '../SkewComponent'
import FormHomePage from '../../FormHomePage'
import uiStore from '../../../utils/UIStore'
import PriceCards from '../PriceCards/index.desktop'
import MobilePriceCards from '../PriceCards/index.mobile'
import {
  DesktopContainer,
  DesktopSectionContainer,
  VideoSectionContainer,
  ContentContainer,
  TextContainer,
  DesktopHeading,
  DesktopDescription,
  DesktopIbcLogo,
  ContentandFormWrapper,
  FormWrapper,
  TabletButtonWrapper,
  DescriptionWrapper,
  NowatContent,
  TabletPriceCardContainer,
  DesktopPriceCardContainer
} from './styledComponents'

class LandingDesktop extends React.Component {
  onClickBookMySlot = () => {
    if (this.sbFormModalRef) {
      this.sbFormModalRef.openModal()
    }
  }

  captureSBFormModalRef = ref => {
    const { captureFormMobileRef } = this.props
    if (ref) {
      this.sbFormModalRef = ref
      captureFormMobileRef(ref)
      uiStore.setMobileSBFormModalRef(ref)
    }
  }
  render() {
    const {
      onFormSubmitSuccess,
      onClickBookMySlot,
      captureFormDesktopRef,
      landingPageDetails,
      priceCardsData,
      openTnCModal,
      videoUrl,
      videoType,
      termsAndConditionsData,
      captureFormMobileRef,
      slotIdPrefix,
      arcadeFormMauticID,
      arcadeCity,
      pagePrefix,
      excludeDates,
      isOnePlusOneOfferPresentInPriceCards
    } = this.props
    // const { priceCardsDesktopImagesList } = priceCardsData
    const landingPageDetailsObject = landingPageDetails
    return (
      <DesktopContainer>
        <DesktopSectionContainer priceCardsData={priceCardsData}>
          <VideoSectionContainer>
            {tablet ? (
              <video
                playsInline
                muted
                autoPlay
                loop
                poster={landingPageDetailsObject.tabletvideoposter}
                data-keepplaying
                id="mautic-player-0"
              >
                <source src={videoUrl} type={videoType} />
              </video>
            ) : (
              <video
                playsInline
                muted
                autoPlay
                loop
                poster={landingPageDetailsObject.desktopvideoposter}
                data-keepplaying
                id="mautic-player-0"
              >
                <source src={videoUrl} type={videoType} />
              </video>
            )}
          </VideoSectionContainer>
          <ContentandFormWrapper>
            {isTabletDesktopDevice ? (
              <ContentContainer>
                <DesktopIbcLogo
                  src={landingPageDetailsObject.logoimageurl}
                  alt="iB Cricket Logo"
                />
                <TextContainer>
                  {landingPageDetailsObject.heading !== '' && (
                    <DesktopHeading as="div">
                      {landingPageDetailsObject.heading}
                    </DesktopHeading>
                  )}
                  <DescriptionWrapper>
                    <DesktopDescription
                      dangerouslySetInnerHTML={{
                        __html: landingPageDetailsObject.desktopdescription
                      }}
                      as="h1"
                    />
                    <NowatContent
                      dangerouslySetInnerHTML={{
                        __html: landingPageDetailsObject.nowatcontent
                      }}
                    />&nbsp;&nbsp;
                    <SkewComponent
                      innerText={landingPageDetailsObject.skewsectioncontent}
                    />
                    <TabletButtonWrapper
                      id={`book-now-button`}
                      onClick={onClickBookMySlot}
                    >
                      <Button>
                        <ButtonTextWithIcon
                          text={landingPageDetailsObject.buttontext}
                        />
                      </Button>
                    </TabletButtonWrapper>
                  </DescriptionWrapper>
                  {/* <PriceCards /> */}
                </TextContainer>
              </ContentContainer>
            ) : null}
            <TabletPriceCardContainer>
              {priceCardsData && (
                <MobilePriceCards
                  ref={this.captureLandingMobileRef}
                  captureFormMobileRef={captureFormMobileRef}
                  onFormSubmitSuccess={onFormSubmitSuccess}
                  termsAndConditionsData={termsAndConditionsData}
                  priceCardsData={priceCardsData}
                />
              )}
            </TabletPriceCardContainer>

            <DesktopPriceCardContainer>
              {priceCardsData && <PriceCards priceCardsData={priceCardsData} />}
            </DesktopPriceCardContainer>

            <FormWrapper
              priceCardsData={priceCardsData}
              id="scroll-to-sb-form"
              className="cd-secondary-nav-container"
            >
              <FormHomePage
                onFormSubmitSuccess={onFormSubmitSuccess}
                ref={captureFormDesktopRef}
                openTnCModal={openTnCModal}
                termsAndConditionsData={termsAndConditionsData}
                slotIdPrefix={slotIdPrefix}
                arcadeFormMauticID={arcadeFormMauticID}
                arcadeCity={arcadeCity}
                pagePrefix={pagePrefix}
                excludeDates={excludeDates}
                priceCardsData={priceCardsData}
                isOnePlusOneOfferPresentInPriceCards={
                  isOnePlusOneOfferPresentInPriceCards
                }
              />
            </FormWrapper>
          </ContentandFormWrapper>
        </DesktopSectionContainer>
      </DesktopContainer>
    )
  }
}

export default LandingDesktop



// WEBPACK FOOTER //
// ./src/components/IbcArcade/LandingPage/index.desktop.js